<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/terms/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Terms and conditions</h1>
          <p class="indent">This website (https://www.alcomet.bg/) is owned by “ALCOMET” AD, a company registered in the Commercial Register and the register of non-profit legal entities maintained by the Registry Agency, with UIC 837066358, with its seat and address of management: Shumen, 2nd Industrial Zone Street, phone: 054/85860, e-mail: legal@alcomet.eu. Business activity: production of aluminum rolled products, aluminum and aluminum alloy products, research and design activities, services for the public, trade in the country and abroad. The administrator of the website is “ALCOMET” AD, acting through its executive directors Hüseyin Umut İnce and Hüseyin Yörücü. For the purposes of these terms and conditions, the administrator will consider any action and/or inaction that violates internet etiquette or causes harm to the administrator or related parties as malicious action.</p>

          <p class="indent">hese terms and conditions govern the use and access to information, information resources, and services on the publicly accessible website. These terms and conditions take effect for each user upon their acceptance, carried out through active behavior by the user, expressed by ticking the consent box, reading, and accepting the Terms and Conditions by each user of the site. </p>

          <p class="indent">
            In this regard, the user declares that:<br>
            •	they are familiar with the content of the terms and conditions;<br>
            •	they accept the terms and conditions;<br>
            •	they are informed of their rights and obligations as a user of the site. We do not collect your personal data through our website. In our business relations as an Administrator, we process personal data in good faith, lawfully, and transparently, and in compliance with the principles of Regulation (EU) 2016/679 and our adopted Privacy Policy and Personal Data Protection Policy available on our site. You have the right to use the information provided on the website in good faith, only to facilitate your business and commercial relations with us. You are not allowed to modify, copy, publish, and/or distribute any part of the content of the website without the explicit written permission from “ALCOMET” AD, nor in any other way violate the copyrights of the textual materials, data, images, and any other information published on this website. “ALCOMET” AD reserves the right to edit the content of this website and to terminate access to it at any time, without prior notice to the users of the website. This website and its content are published for your convenience. “ALCOMET” AD does not guarantee that the web pages are error-free and that access to them is uninterrupted. We are not responsible for any loss of information during the reloading of the website or when copying materials, images, text, and other information from it. The published trademarks, logos, and main elements of the corporate identity of “ALCOMET” AD are registered as corporate signs and are protected according to the laws of the Republic of Bulgaria and international standards. All materials on this site are protected by the Copyright and Related Rights Act. On the site, you will find information about our products. To place commercial orders, you can contact our employees through the contacts listed on our site. The main regulatory acts that “ALCOMET” AD adheres to in conducting its business are: the Public Offering of Securities Act and its implementation regulations, the Commerce Act, the Accounting Act, the Copyright and Related Rights Act, the Independent Financial Audit Act, the Internal Audit in the Public Sector Act, the Market Abuse with Financial Instruments Act, National and International Accounting Standards, as well as internationally recognized principles of good corporate governance, the Labor Code, the National Corporate Governance Code, and others.<br>

          </p>



        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}


@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue